import { Redirect, Switch } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Loading } from '@fides/fides-react-components';
import { PrivateRoute } from '../helpers';

const Debug = React.lazy(() => import('../../components/pages/Dev/Debug'));
const UserInfo = React.lazy(() => import('../../components/pages/Dev/UserInfo'));
const PaymentView = React.lazy(() => import('../../components/pages/Payments/PaymentView'));
const TransactionView = React.lazy(() => import('../../components/pages/Payments/TransactionView'));
const PaymentWizard = React.lazy(() => import('../../components/pages/Payments/PaymentWizard'));
const SimplifiedPaymentWizard = React.lazy(() => import('../../components/pages/Payments/SimplifiedPaymentWizard'));

export const DevRouter = () => {
  return (
    <Switch>
      <PrivateRoute path='/dev/user-information' exact>
        <Suspense fallback={<Loading />}>
          <UserInfo />
        </Suspense>
      </PrivateRoute>
      {/* <PrivateRoute path='/dev/payment' exact>
        <Suspense fallback={<Loading />}>
          <PaymentView />
        </Suspense>
      </PrivateRoute>
      <PrivateRoute path='/dev/payment/add' exact>
        <Suspense fallback={<Loading />}>
          <PaymentWizard />
        </Suspense>
      </PrivateRoute>
      <PrivateRoute path='/dev/payment/addSme' exact>
        <Suspense fallback={<Loading />}>
          <SimplifiedPaymentWizard />
        </Suspense>
      </PrivateRoute>
      <PrivateRoute path='/dev/payment/transaction/:uniqueId?' exact>
        <Suspense fallback={<Loading />}>
          <TransactionView />
        </Suspense>
      </PrivateRoute> */}
      <PrivateRoute path='/dev/debug' exact>
        <Suspense fallback={<Loading />}>
          <Debug />
        </Suspense>
      </PrivateRoute>
      <Redirect from='/dev/' to='/dev/user-information' exact />
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
